import { countries } from 'src/features/details-form/constants';
import { UserDetailsPartial } from 'src/auth/types';
import { AgentUserDetails } from 'src/features/your-details/user-form/types';

export type UserInfo = {
    address_1?: string | null;
    address_2?: string | null;
    city?: string | null;
    postcode?: string | null;
    country?: string | null;
    nif_number?: string | null;
    nie_number?: string | null;
    passport_number?: string | null;
    passport_issuing_country?: string | null;
};

export const getValidCountry = (country?: string | null) =>
    country && countries.some((c) => c.value === country) ? country : 'United Kingdom';

export const hasAddressDetails = (
    userDetails?: UserDetailsPartial,
    userInfo?: UserInfo,
    agentUserDetails?: AgentUserDetails
) =>
    Boolean(
        userDetails?.address1 ||
            userDetails?.address2 ||
            userDetails?.city ||
            userDetails?.postCode ||
            userDetails?.country ||
            userInfo?.address_1 ||
            userInfo?.address_2 ||
            userInfo?.city ||
            userInfo?.postcode ||
            userInfo?.country ||
            agentUserDetails?.address1 ||
            agentUserDetails?.address2 ||
            agentUserDetails?.city ||
            agentUserDetails?.postCode ||
            agentUserDetails?.country
    );

export const getAddressDefaults = (
    userDetails?: UserDetailsPartial,
    userInfo?: UserInfo,
    agentUserDetails?: AgentUserDetails
) => {
    const hasAddress = hasAddressDetails(userDetails, userInfo, agentUserDetails);
    const dashOrNull = hasAddress ? '-' : undefined;

    return {
        address1:
            userDetails?.address1 ??
            userInfo?.address_1 ??
            agentUserDetails?.address1 ??
            dashOrNull,
        address2:
            userDetails?.address2 ??
            userInfo?.address_2 ??
            agentUserDetails?.address2 ??
            dashOrNull,
        city: userDetails?.city ?? userInfo?.city ?? agentUserDetails?.city ?? dashOrNull,
        postCode:
            userDetails?.postCode ?? userInfo?.postcode ?? agentUserDetails?.postCode ?? dashOrNull,
        country: getValidCountry(
            userDetails?.country ?? userInfo?.country ?? agentUserDetails?.country
        ),
    };
};
